export default __webpack_public_path__ + "static/media/asc.ee0c4477.jpg";